/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowResponse } from '../../models/workflow-response';

export interface GetApiPublicWorkflows$Params {

/**
 * ID of an agency
 */
  agency_id: string;

/**
 * ID of a service
 */
  service_id: string;
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicWorkflows(http: HttpClient, rootUrl: string, params: GetApiPublicWorkflows$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicWorkflows.PATH, 'get');
  if (params) {
    rb.query('agency_id', params.agency_id, {});
    rb.query('service_id', params.service_id, {});
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowResponse>;
    })
  );
}

getApiPublicWorkflows.PATH = '/api/public/{_locale}/workflows';
